$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight(); var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height(); return elementBottom > viewportTop && elementTop < viewportBottom;
};

const options = {
    separator: ' ',
};

$('.js-countup').each(function() {
    var t = $(this),
        id = t.attr('id'),
        number = t.attr('data-number');
        
    var counter = new CountUp(id, number, options);

    $(window).on('resize scroll ready load', function () {
        if (t.isInViewport()) {
            if (counter.paused == true) {
                counter.start();
            }
        }
    });

    
});